export default __webpack_public_path__ + "static/media/signature_1.b003a096.png";